import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function RejectionModal({
  show,
  onHide,
  onConfirm,
  itemName,
  allowFileUpload = false,
  fileLabel = "Attach File",
  fileAccept = ".xlsx,.xls",
}) {
  const [comments, setComments] = useState("");
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [fileError, setFileError] = useState("");

  const isCommentsRequired = false;

  useEffect(() => {
    if (!show) {
      setAttachmentFile(null);
      setFileError("");
    }
  }, [show]);

  const handleConfirm = () => {
    if (isCommentsRequired && !comments.trim()) {
      return;
    }

    if (allowFileUpload && attachmentFile) {
      const allowedExtensions = [".xlsx", ".xls"];
      const extension = attachmentFile.name
        .substring(attachmentFile.name.lastIndexOf("."))
        .toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        setFileError("Please select a valid Excel file (.xlsx or .xls)");
        return;
      }
    }

    onConfirm(comments, attachmentFile || null);
    setComments("");
    setAttachmentFile(null);
    setFileError("");
    onHide();
  };

  const handleCancel = () => {
    setComments("");
    setAttachmentFile(null);
    setFileError("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title className="my-0">
          <>
            <i className="mdi mdi-close-circle text-danger me-2"></i>
            Reject Item
          </>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          You are about to reject: <br />
          <strong>{itemName}</strong>
        </p>
        <Form.Group>
          <Form.Label>
            Rejection Comments{" "}
            {isCommentsRequired ? (
              <span className="text-danger">(Required)</span>
            ) : (
              <span className="text-muted">(Optional)</span>
            )}
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Enter reason for rejection (optional)..."
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            isInvalid={isCommentsRequired && comments.trim() === ""}
          />
          {isCommentsRequired && comments.trim() === "" && (
            <Form.Control.Feedback type="invalid">
              Rejection comments are required.
            </Form.Control.Feedback>
          )}
        </Form.Group>

        {allowFileUpload && (
          <Form.Group className="mt-3">
            <Form.Label>{fileLabel}</Form.Label>
            <Form.Control
              type="file"
              accept={fileAccept}
              onChange={(e) => {
                setAttachmentFile(e.target.files?.[0] || null);
                setFileError("");
              }}
              isInvalid={!!fileError}
            />
            {fileError && (
              <Form.Control.Feedback type="invalid">
                {fileError}
              </Form.Control.Feedback>
            )}
            <small className="text-muted">Optional: .xlsx or .xls</small>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={handleConfirm}
          disabled={isCommentsRequired && !comments.trim()}
        >
          <>
            <i className="mdi mdi-close-circle me-1"></i>
            Confirm Rejection
          </>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
